import { Component, OnInit } from '@angular/core';
import { ContractService, SupportDataService } from '../../_services';
import { ContractBase } from "./contract.base";

@Component({
	selector: 'contract-term-possession',
	template: require('./contract-term-possession.template.html')
})
export class ContractTermPossessionComponent extends ContractBase implements OnInit {

	actions$: Promise<any[]>;

	constructor(
		private readonly api: SupportDataService,
		protected readonly contractService: ContractService) {
		super(contractService);
	}

	get termPossession(): any {
		const contract: any = this.contract;
		return contract != null && this.store != null ? contract.termPossession : null;
	}

	get reactionTimeAlarm(): string {
		const contract: any = this.contract;
		if (contract == null) return "-";
		const tp = contract.termPossession;
		if (tp == null) return "-";
		return tp.remainingTimeDays > 0 ?
			`${tp.remainingTimeDays} / ${tp.remainingTimeYears}` :
			"-";
	}

	ngOnInit(): void {
		this.actions$ = this.api.contract.actions();
	}

	ngOnDestroy(): void {
	}


}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/contract/contract-term-possession.component.ts